import { h } from 'preact'

export default props =>
   <button {...props} />


// WEBPACK FOOTER //
// ./js/components/Button.js